import actions from '../constants/actions'

const sessionData = (state = [], action) => {
    switch (action.type) {
        case 'SESSION_START_SUCCESS':
            return {
                ...state,
                clientSettings: {
                    name: action.name,
                    forceAllAccounts: action.forceAllAccounts,
                    forceSingleAccount: action.forceSingleAccount,
                    forceNoAccounts: action.forceNoAccounts,
                    requiresEstatements: action.requiresEstatements,
                    requestAllAccounts: action.requestAllAccounts,
                    numberOfDays: action.numberOfDays,
                    nameRequired: action.iFrameAskForName,
                    redirectUrl: action.redirectUrl,
                    requireWinz:action.requireWinz
                }
            }        
        case actions.TERMS_ACCEPTED:
            return {
                ...state,
                acceptedTerms: true,
                userFullName: action.userFullName
            }
        case actions.PRECONSENT_FINISHED:
            return {
                ...state,
                preconsentFinished: action.preconsentFinished,
                consentCustomerId: action.consentCustomerId
            }
        case actions.STORE_PRECONSENT_FORM_DATA:
            return {
                ...state,
                preConsentFormData: {
                    given_name: action.given_name,
                    surname: action.surname,
                    email: action.email,
                    phone: action.phone,
                    errors: action.errors                    
                }
            }
        default:
            return state
        }
}

export default sessionData